var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEuroCircleFilled = function SvgEuroCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1M8 12q0-.255.031-.5H11a1 1 0 1 0 0-2H8.877A4 4 0 0 1 12 8c1.025 0 1.958.384 2.666 1.018A1 1 0 0 0 16 7.528 6.001 6.001 0 0 0 6.544 9.5H6a1 1 0 0 0 0 2h.02a6 6 0 0 0 0 1H6a1 1 0 1 0 0 2h.544A6 6 0 0 0 16 16.472a1 1 0 1 0-1.334-1.49A3.98 3.98 0 0 1 12 16a4 4 0 0 1-3.123-1.5H11a1 1 0 1 0 0-2H8.031A4 4 0 0 1 8 12",
    clipRule: "evenodd"
  })));
};
export default SvgEuroCircleFilled;